import { render, staticRenderFns } from "./person.vue?vue&type=template&id=1817bd02&scoped=true&"
import script from "./person.vue?vue&type=script&lang=js&"
export * from "./person.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/common/form.less?vue&type=style&index=0&id=1817bd02&scoped=true&lang=less&"
import style1 from "../../assets/css/common/nav.less?vue&type=style&index=1&id=1817bd02&scoped=true&lang=less&"
import style2 from "../../assets/css/common/details.less?vue&type=style&index=2&id=1817bd02&scoped=true&lang=less&"
import style3 from "../../assets/css/common/additional.less?vue&type=style&index=3&id=1817bd02&scoped=true&lang=less&"
import style4 from "./person.vue?vue&type=style&index=4&id=1817bd02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1817bd02",
  null
  
)

export default component.exports